<template>
  <div class="tabs">
    <el-tabs
      v-model="activeName" type="border-card"
      @tab-click="handleTabClick"
    >
      <!--      v-permit:remove="'btn:aRGenerationNew:ExpressReceivables:index'"-->
      <el-tab-pane
        :label="$t('basicData.ExpressReceivables')" name="ExpressReceivables" lazy
      >
        <!--        <div v-if="activeName === 'ExpressReceivables'">-->
        <ExpressReceivables ref="ExpressReceivables" />
        <!--        </div>-->
      </el-tab-pane>
      <el-tab-pane
        :label="$t('basicData.FullTruckloadReceivables')" name="VehicleReceivables" lazy
      >
        <!--        <div v-if="activeName === 'VehicleReceivables'">-->
        <VehicleReceivables ref="VehicleReceivables" />
        <!--        </div>-->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  components: {
    ExpressReceivables: () => import('./ExpressReceivables'),
    VehicleReceivables: () => import('./VehicleReceivables')
  },
  data() {
    return {
      activeName: 'ExpressReceivables'
    };
  },

  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs {
  border: none;
}

//::v-deep .el-tabs--border-card>.el-tabs__content {
//  padding: 0;
//}
</style>
